import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter'; // Inter servida desde la propia web (sin Google Fonts)
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
